<template>
    <div id="transitDelayActionDisplay">
        <div v-if="delaySelected" class="delayInProgess">
            <delay-action :delay="delaySelected" :tripId="tripId"/>
        </div>
        <div v-else class="noDelayYet">
            <delay-action :delay="delay" v-for="delay in delaysByStage" :key="delay.id" :tripId="tripId"/>
        </div>
    </div>
</template>

<script>
    import DelayAction from '../custom-components/DelayAction.vue'

    export default {
        props: [
            'tripId',
        ],
        components: {
            'delay-action': DelayAction
        },
        computed: {
            trip() {
                return this.$privateReactiveStore.getTrip(this.tripId);
            },
            actionStage() {
                return this.trip.transit_action_stage;
            },
            delaysByStage() {
                return this.$privateReactiveStore.getDelaysInStage(this.actionStage);
            },
            delaySelected() {
                return this.trip.transit_delay_id != null ? this.$privateReactiveStore.getDelay(this.trip.transit_delay_id) : null;
            }
        }
    }
</script>

<style scoped>
    #transitDelayActionDisplay {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        height: 40vh;
        width: 80%;
    }

    .noDelayYet {
        width: 100%;
    }

    #transitDelayActionDisplay .delayInProgess {
        justify-content: center;
        width: 100%;
    }
</style>